/** Tự sinh bởi scripts/fetch-funds.mjs lúc build — không sửa tay. */
export default [
  {
    "fundId": "2080-ventures",
    "slug": "2080-ventures",
    "name": "2080 Ventures",
    "shortName": "2080 Ventures",
    "type": "VC",
    "vietnamPresence": "INVESTED",
    "vietnamEvidence": "Trang chính thức nêu Việt Nam trong phạm vi đầu tư và vận hành chương trình hỗ trợ cho hệ sinh thái khởi nghiệp Việt Nam.",
    "website": "https://2080.ventures",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "AI",
        "FINTECH",
        "HEALTHTECH",
        "ENERGY",
        "EDTECH",
        "WEB3"
      ],
      "stages": [
        "PRESEED",
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://2080.ventures/get-in-touch",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": "Trang liên hệ chính thức."
    },
    "content": {
      "summary": "Nền tảng kết hợp đầu tư và hỗ trợ hệ sinh thái, hoạt động tại Việt Nam và Đông Nam Á, nhắm vào công nghệ giai đoạn sớm.",
      "lookingFor": [],
      "tips": [
        "Quỹ không công bố quy mô séc trên trang chính thức. Hỏi thẳng trong buổi đầu.",
        "Ngoài đầu tư trực tiếp, đơn vị này còn tham gia tài trợ và đồng hành cùng một số chương trình khởi nghiệp tại Việt Nam — đáng theo dõi cả hai kênh."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "Cerebras",
          "url": "",
          "whatTheyDo": "Thiết kế chip chuyên dụng cỡ lớn để huấn luyện mô hình AI.",
          "industries": [
            "SEMICONDUCTOR",
            "AI"
          ],
          "stage": "",
          "geo": "GLOBAL",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "SpaceX",
          "url": "",
          "whatTheyDo": "Chế tạo tên lửa tái sử dụng và vận hành mạng internet vệ tinh.",
          "industries": [
            "MANUFACTURING"
          ],
          "stage": "",
          "geo": "GLOBAL",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Animoca Brands",
          "url": "",
          "whatTheyDo": "Phát triển và đầu tư game blockchain.",
          "industries": [
            "WEB3",
            "GAMING"
          ],
          "stage": "",
          "geo": "APAC",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Bamboo",
          "url": "",
          "whatTheyDo": "Ứng dụng cho nhà đầu tư châu Phi mua cổ phiếu niêm yết tại Mỹ.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "GLOBAL",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Yummy",
          "url": "",
          "whatTheyDo": "Siêu ứng dụng giao đồ ăn và đi chợ hộ tại Venezuela.",
          "industries": [
            "FOODBEV",
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "GLOBAL",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Trang danh mục của quỹ nêu doanh nghiệp ở nhiều nước và thiên về công nghệ sâu; chưa có doanh nghiệp Việt Nam nào được nêu công khai.",
      "source": "https://2080.ventures",
      "verifiedAt": "2026-09-26"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://2080.ventures/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        },
        {
          "url": "https://2080.ventures/get-in-touch",
          "fetchedAt": "2026-09-11",
          "note": "Kênh liên hệ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T08:55:26.445Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "500-global-vietnam",
    "slug": "500-global-vietnam",
    "name": "500 Global — Việt Nam và Đông Nam Á",
    "shortName": "500 Global",
    "type": "VC",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://vietnam.500.co",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "FINTECH",
        "SAAS_B2B",
        "AGRITECH",
        "FOODBEV",
        "HEALTHTECH",
        "CLIMATE"
      ],
      "stages": [
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 25000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 50000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "OFFICIAL",
        "confidence": "HIGH",
        "hardFilter": true,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://sea.500.co/get-in-touch/pitch-for-investment",
      "submitEmail": "",
      "ctaType": "apply",
      "notes": "Nộp hồ sơ qua biểu mẫu pitch của chương trình Đông Nam Á."
    },
    "content": {
      "summary": "Nền tảng đầu tư toàn cầu có microsite riêng cho Việt Nam và quỹ dành cho khu vực Đông Nam Á.",
      "lookingFor": [],
      "tips": []
    },
    "portfolio": {
      "items": [
        {
          "name": "Grab",
          "url": "",
          "whatTheyDo": "Siêu ứng dụng gọi xe, giao đồ ăn và thanh toán tại Đông Nam Á.",
          "industries": [
            "MOBILITY",
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcome": "IPO",
          "outcomeNote": "Niêm yết trên sàn Nasdaq năm 2021."
        },
        {
          "name": "Bukalapak",
          "url": "",
          "whatTheyDo": "Sàn thương mại điện tử và dịch vụ cho tiệm tạp hoá tại Indonesia.",
          "industries": [
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcome": "IPO",
          "outcomeNote": "Niêm yết trên sàn chứng khoán Indonesia năm 2021."
        },
        {
          "name": "Carousell",
          "url": "",
          "whatTheyDo": "Sàn rao vặt mua bán đồ đã qua sử dụng tại Đông Nam Á.",
          "industries": [
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Carsome",
          "url": "",
          "whatTheyDo": "Nền tảng mua bán và kiểm định ô tô đã qua sử dụng.",
          "industries": [
            "ECOMMERCE",
            "MOBILITY"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "FinAccel",
          "url": "",
          "whatTheyDo": "Công ty mẹ của Kredivo, cho vay tiêu dùng và mua trước trả sau.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Quỹ nêu tên một số doanh nghiệp đã vượt mốc định giá 1 tỷ USD; danh mục Đông Nam Á của quỹ hơn 300 doanh nghiệp, phần lớn không công bố.",
      "source": "https://vietnam.500.co",
      "verifiedAt": "2026-09-24"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://sea.500.co/get-in-touch/pitch-for-investment",
          "fetchedAt": "2026-09-15",
          "note": "Biểu mẫu nhận pitch của 500 Southeast Asia"
        },
        {
          "url": "https://500.co/southeast-asia",
          "fetchedAt": "2026-09-15",
          "note": "Trang chương trình Đông Nam Á: séc 250–500 nghìn USD, các nhóm ngành ưu tiên"
        },
        {
          "url": "https://vietnam.500.co/",
          "fetchedAt": "2026-09-11",
          "note": "Microsite Việt Nam"
        },
        {
          "url": "https://500.co/sea",
          "fetchedAt": "2026-09-11",
          "note": "Trang khu vực Đông Nam Á"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-27T08:55:25.119Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "angelcentral-vietnam",
    "slug": "angelcentral-vietnam",
    "name": "AngelCentral Việt Nam",
    "shortName": "AngelCentral",
    "type": "ANGEL_NETWORK",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://www.angelcentral.vn",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "PRESEED",
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.angelcentral.vn/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": "Nộp hồ sơ để được sàng lọc và mời pitch trước mạng lưới nhà đầu tư."
    },
    "content": {
      "summary": "Mạng lưới nhà đầu tư thiên thần hoạt động tại Việt Nam và Đông Nam Á, kết nối startup với các nhà đầu tư cá nhân qua buổi pitch có sàng lọc.",
      "lookingFor": [],
      "tips": [
        "Đây là kênh kết nối, không phải một quỹ ra quyết định tập trung. Quy mô mỗi khoản phụ thuộc từng nhà đầu tư tham gia.",
        "Được mời pitch không đồng nghĩa gọi được vốn. Nhưng đây là một trong ít kênh tiếp cận nhà đầu tư cá nhân có tổ chức tại Việt Nam."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.angelcentral.vn/",
          "fetchedAt": "2026-09-12",
          "note": "Trang Việt Nam chính thức"
        },
        {
          "url": "https://www.angelcentral.co/",
          "fetchedAt": "2026-09-12",
          "note": "Trang mạng lưới khu vực"
        }
      ],
      "lastVerifiedAt": "2026-09-12"
    },
    "updatedAt": "2026-09-20T14:36:01.220Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "antler-vietnam",
    "slug": "antler-vietnam",
    "name": "Antler Vietnam",
    "shortName": "Antler",
    "type": "ACCELERATOR",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://www.antler.co/location/vietnam",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "IDEA",
        "PROTOTYPE",
        "PRESEED"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [
        "SAFE"
      ],
      "ticket": {
        "min": {
          "amount": 12000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 12000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        }
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.antler.co/pitch",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": "Nhận hồ sơ liên tục, không theo đợt."
    },
    "content": {
      "summary": "Chương trình residency tại TP.HCM dành cho người sáng lập giai đoạn rất sớm, kể cả khi chưa có đồng sáng lập hay sản phẩm. Đầu tư 120 nghìn USD đổi 12% cổ phần qua SAFE.",
      "lookingFor": [],
      "tips": [
        "Đây là chương trình cư trú, thường yêu cầu có mặt tại TP.HCM trong vài tuần. Cân nhắc yếu tố thời gian trước khi nộp.",
        "Ngoài khoản ban đầu còn có phần đầu tư đối ứng và rót thêm ở vòng sau, nhưng đó là các khoản riêng với điều kiện riêng."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "Alterno",
          "url": "",
          "whatTheyDo": "Lưu trữ nhiệt và điện bằng cát, có bằng sáng chế tại Mỹ.",
          "industries": [
            "CLIMATE",
            "ENERGY"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2023",
          "outcomeNote": ""
        },
        {
          "name": "Buyo",
          "url": "",
          "whatTheyDo": "Biến phụ phẩm sinh học bỏ đi thành vật liệu tự phân huỷ hoàn toàn.",
          "industries": [
            "CLIMATE",
            "MATERIALS"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2022",
          "outcomeNote": ""
        },
        {
          "name": "Wareflex",
          "url": "",
          "whatTheyDo": "Nền tảng B2B đặt dịch vụ kho bãi và vận chuyển.",
          "industries": [
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2022",
          "outcomeNote": ""
        },
        {
          "name": "Inflow",
          "url": "",
          "whatTheyDo": "Nền tảng chuỗi cung ứng và sản xuất cho thương hiệu thời trang.",
          "industries": [
            "MANUFACTURING",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2022",
          "outcomeNote": ""
        },
        {
          "name": "Aircity",
          "url": "",
          "whatTheyDo": "Phần mềm quản lý vận hành toà nhà và bất động sản cho thuê.",
          "industries": [
            "PROPTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2022",
          "outcomeNote": ""
        },
        {
          "name": "Neoloka",
          "url": "",
          "whatTheyDo": "Mạng lưới điểm dịch vụ tại chỗ cho giao hàng chặng cuối.",
          "industries": [
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2022",
          "outcomeNote": ""
        },
        {
          "name": "Tribee",
          "url": "",
          "whatTheyDo": "Huấn luyện đội bán hàng dựa trên dữ liệu, có hỗ trợ AI.",
          "industries": [
            "SAAS_B2B",
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2021",
          "outcomeNote": ""
        },
        {
          "name": "Megasop",
          "url": "",
          "whatTheyDo": "Nền tảng số cho mạng lưới phân phối và bán lẻ hiện đại.",
          "industries": [
            "SAAS_B2B",
            "RETAILTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2023",
          "outcomeNote": ""
        }
      ],
      "note": "Antler đầu tư từ lúc đội ngũ mới thành lập nên phần lớn danh mục là doanh nghiệp rất sớm. Mô tả lấy theo đúng cách quỹ ghi trên trang.",
      "source": "https://www.antler.co/location/vietnam",
      "verifiedAt": "2026-09-26"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.antler.co/location/vietnam",
          "fetchedAt": "2026-09-11",
          "note": "Trang chương trình Việt Nam"
        },
        {
          "url": "https://www.antler.co/location/vietnam#faq",
          "fetchedAt": "2026-09-11",
          "note": "Hỏi đáp — điều kiện và quy mô đầu tư"
        },
        {
          "url": "https://www.antler.co/pitch",
          "fetchedAt": "2026-09-11",
          "note": "Kênh nộp hồ sơ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T08:55:22.471Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "ascend-vietnam-ventures",
    "slug": "ascend-vietnam-ventures",
    "name": "Ascend Vietnam Ventures",
    "shortName": "AVV",
    "type": "VC",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://avv.co",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "AI",
        "FINTECH",
        "EDTECH",
        "SAAS_B2B",
        "ECOMMERCE",
        "HEALTHTECH",
        "AGRITECH",
        "GAMING",
        "WEB3"
      ],
      "stages": [
        "IDEA",
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 25000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 200000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        }
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://avv.co/connect",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": "Trang Pitch Us có biểu mẫu và chỗ tải pitch deck."
    },
    "content": {
      "summary": "Quỹ đầu tư giai đoạn sớm gốc Việt Nam, séc ban đầu từ 250 nghìn tới 2 triệu USD, có thể rót thêm tới 5 triệu USD ở vòng sau.",
      "lookingFor": [],
      "tips": [
        "Con số 5 triệu USD hay được nhắc tới là mức rót thêm cộng dồn, không phải séc của một vòng."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "TechCoop",
          "url": "",
          "whatTheyDo": "Nền tảng vốn, vật tư và đầu ra cho hợp tác xã nông nghiệp.",
          "industries": [
            "AGRITECH",
            "FINTECH"
          ],
          "stage": "SERIES_A",
          "geo": "VN",
          "roundDate": "2025-02",
          "roundSize": {
            "amount": 7000000000,
            "ccy": "USD",
            "fx": 26170,
            "fxDate": "2026-09-09"
          },
          "roundSource": "https://en.vneconomy.vn/vietnamese-agri-tech-startup-secures-70-mln-in-series-a-financing.htm",
          "leadInvestor": true,
          "outcomeNote": ""
        },
        {
          "name": "Sky Mavis",
          "url": "",
          "whatTheyDo": "Hạ tầng game blockchain, đơn vị tạo ra Axie Infinity.",
          "industries": [
            "WEB3",
            "GAMING"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Trusting Social",
          "url": "",
          "whatTheyDo": "Chấm điểm tín dụng bằng dữ liệu thay thế cho người chưa có lịch sử ngân hàng.",
          "industries": [
            "FINTECH",
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Turing",
          "url": "",
          "whatTheyDo": "Tuyển và vận hành đội kỹ sư phần mềm từ xa cho doanh nghiệp toàn cầu.",
          "industries": [
            "HRTECH",
            "AI"
          ],
          "stage": "",
          "geo": "GLOBAL",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Obello",
          "url": "",
          "whatTheyDo": "Công cụ AI tạo ấn phẩm thiết kế đúng bộ nhận diện thương hiệu.",
          "industries": [
            "AI",
            "MARTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Vaudit",
          "url": "",
          "whatTheyDo": "Kiểm tra chi tiêu quảng cáo số theo thời gian thực bằng AI.",
          "industries": [
            "MARTECH",
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Vòng Series A của TechCoop gồm cả phần vốn vay bên cạnh vốn cổ phần.",
      "source": "https://avv.co/portfolio",
      "verifiedAt": "2026-09-25"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://avv.co/about",
          "fetchedAt": "2026-09-11",
          "note": "Trang giới thiệu"
        },
        {
          "url": "https://avv.co/faq",
          "fetchedAt": "2026-09-11",
          "note": "Trang hỏi đáp — giai đoạn, ngành, quy mô séc"
        },
        {
          "url": "https://avv.co/connect",
          "fetchedAt": "2026-09-11",
          "note": "Kênh nộp hồ sơ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T08:55:21.073Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "b-capital-early",
    "slug": "b-capital-early",
    "name": "B Capital — Early Stage",
    "shortName": "B Capital Early",
    "type": "VC",
    "vietnamPresence": "INVESTED",
    "vietnamEvidence": "Quỹ nêu Việt Nam trong phạm vi hoạt động hoặc có thương vụ tại Việt Nam.",
    "website": "https://b.capital",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "AI",
        "SAAS_B2B",
        "HEALTHTECH",
        "CLIMATE"
      ],
      "stages": [
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN",
        "APAC",
        "GLOBAL"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 50000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 1000000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "PRESS",
        "confidence": "MEDIUM",
        "hardFilter": false,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://b.capital/contact/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": "Liên hệ qua biểu mẫu trên website."
    },
    "content": {
      "summary": "Nhánh đầu tư giai đoạn sớm của B Capital, lập năm 2026, đầu tư vào công nghệ, y tế và khí hậu.",
      "lookingFor": [],
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://b.capital/",
          "fetchedAt": "2026-09-15",
          "note": "Trang chủ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-20T14:43:55.912Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "b-capital-growth",
    "slug": "b-capital-growth",
    "name": "B Capital — Growth",
    "shortName": "B Capital",
    "type": "VC",
    "vietnamPresence": "INVESTED",
    "vietnamEvidence": "Quỹ nêu Việt Nam trong phạm vi hoạt động hoặc có thương vụ tại Việt Nam.",
    "website": "https://b.capital",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "SAAS_B2B",
        "AI",
        "CYBERSECURITY",
        "FINTECH",
        "HEALTHTECH",
        "LOGISTICS"
      ],
      "stages": [
        "LATER"
      ],
      "geos": [
        "VN",
        "APAC",
        "GLOBAL"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 1000000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 6000000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "OFFICIAL",
        "confidence": "HIGH",
        "hardFilter": true,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://b.capital/contact/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": ""
    },
    "content": {
      "summary": "Nền tảng đầu tư đa giai đoạn toàn cầu, đã tham gia vòng lớn tại Việt Nam.",
      "lookingFor": [],
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://b.capital/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-20T14:45:12.368Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "beacon-fund",
    "slug": "beacon-fund",
    "name": "Beacon Fund",
    "shortName": "Beacon",
    "type": "LENDER",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://beaconfund.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "DEBT"
      ],
      "industries": [],
      "stages": [],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "requiresRevenue": true,
      "hardRequirements": [
        {
          "code": "DO_PHU_NU_LANH_DAO",
          "field": "identity.womenLed",
          "op": "isTrue",
          "label": "Doanh nghiệp do phụ nữ sở hữu hoặc lãnh đạo, hoặc phục vụ chủ yếu phụ nữ và trẻ em gái"
        },
        {
          "code": "BA_NAM_BAO_CAO",
          "field": "finance.yearsOfFinancials",
          "op": "gte",
          "value": 3,
          "label": "Có ít nhất 3 năm báo cáo tài chính lập theo chuẩn mực kế toán Việt Nam"
        }
      ]
    },
    "process": {
      "submitUrl": "https://beaconfund.com/contact/",
      "submitEmail": "info@beaconfund.com",
      "ctaType": "apply",
      "notes": "Trang Cách chúng tôi đầu tư có nút \"Apply for Our Funding\" dẫn tới biểu mẫu."
    },
    "content": {
      "summary": "Quỹ cho vay tư nhân đặt tại TP.HCM, cấp khoản vay trung hạn cho doanh nghiệp vừa và nhỏ do phụ nữ lãnh đạo. Không lấy cổ phần và không yêu cầu thế chấp bất động sản.",
      "lookingFor": [
        "Doanh nghiệp do phụ nữ sở hữu hoặc lãnh đạo, hoặc phục vụ chủ yếu phụ nữ và trẻ em gái",
        "Doanh nghiệp đã có dòng tiền dương, tăng trưởng đều — không cần mô hình tăng trưởng bùng nổ",
        "Có tác động xã hội đo lường được bên cạnh yếu tố giới"
      ],
      "tips": [
        "Quỹ tự mô tả nhắm vào \"khoảng giữa còn thiếu\": doanh nghiệp quá lớn cho tài chính vi mô, quá nhỏ cho quỹ đầu tư tư nhân, không hợp mô hình tăng trưởng của vốn mạo hiểm, và thiếu tài sản thế chấp để vay ngân hàng.",
        "Nếu doanh nghiệp của bạn có doanh thu ổn định nhưng bị quỹ mạo hiểm từ chối vì thị trường không đủ lớn, đây là hướng đáng xem."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "MindX Technology School",
          "url": "",
          "whatTheyDo": "Trường dạy lập trình cho học sinh lớp 5-12 và người đi làm trẻ.",
          "industries": [
            "EDTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "CAS Energy",
          "url": "",
          "whatTheyDo": "Năng lượng tái tạo và nông nghiệp thông minh thích ứng biến đổi khí hậu.",
          "industries": [
            "ENERGY",
            "AGRITECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Hoa Nắng Organic",
          "url": "",
          "whatTheyDo": "Doanh nghiệp lúa gạo khép kín, đạt chứng nhận hữu cơ USDA và EU.",
          "industries": [
            "AGRITECH",
            "FOODBEV"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Hoa Sen Việt Group",
          "url": "",
          "whatTheyDo": "Bán lẻ mỹ phẩm và sản phẩm chăm sóc da nhiều thương hiệu.",
          "industries": [
            "RETAILTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Lotus Group",
          "url": "",
          "whatTheyDo": "Doanh nghiệp thực phẩm đồ uống vận hành chuỗi nhà hàng Nhật.",
          "industries": [
            "FOODBEV"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "TIMEC",
          "url": "",
          "whatTheyDo": "Cơ sở y tế cung cấp dịch vụ khám chữa bệnh chi phí vừa phải.",
          "industries": [
            "HEALTHTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Komarc",
          "url": "",
          "whatTheyDo": "Sản xuất đồ chơi và giáo cụ cho các thương hiệu toàn cầu.",
          "industries": [
            "MANUFACTURING"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Bồ Câu Services",
          "url": "",
          "whatTheyDo": "Hạ tầng viễn thông, dẫn đầu thị trường trong nước.",
          "industries": [
            "OTHER"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Beacon Fund cấp vốn vay và vốn hoàn trả chứ không đổi cổ phần — “danh mục” ở đây là các doanh nghiệp đã được cấp vốn. Mô tả lấy theo đúng cách quỹ ghi trên trang.",
      "source": "https://beaconfund.com/our-portfolio/",
      "verifiedAt": "2026-09-26"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://beaconfund.com/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức — mô tả sản phẩm cho vay và đối tượng"
        },
        {
          "url": "https://beaconfund.com/how-we-invest",
          "fetchedAt": "2026-09-11",
          "note": "Trang Cách chúng tôi đầu tư — đối tượng, địa bàn, kênh nộp hồ sơ"
        },
        {
          "url": "https://beaconfund.com/faqs/",
          "fetchedAt": "2026-09-11",
          "note": "Trang hỏi đáp — yêu cầu 3 năm báo cáo tài chính, kênh liên hệ"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T08:55:19.738Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "beenext",
    "slug": "beenext",
    "name": "BEENEXT",
    "shortName": "BEENEXT",
    "type": "VC",
    "vietnamPresence": "INVESTED",
    "vietnamEvidence": "Đã đầu tư vào doanh nghiệp Việt Nam; quỹ nêu Việt Nam trong phạm vi hoạt động.",
    "website": "https://www.beenext.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "PRESEED",
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN",
        "SEA",
        "APAC"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.beenext.com/contact/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư giai đoạn sớm hoạt động tại châu Á, đã có thương vụ tại Việt Nam.",
      "lookingFor": [],
      "tips": [
        "Quỹ tự mô tả không giới hạn ngành. Việc đã đầu tư tại Việt Nam không đồng nghĩa có văn phòng riêng ở đây."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.beenext.com/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        },
        {
          "url": "https://www.beenext.com/contact/",
          "fetchedAt": "2026-09-11",
          "note": "Kênh liên hệ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T09:11:53.631Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "cocoon-capital",
    "slug": "cocoon-capital",
    "name": "Cocoon Capital",
    "shortName": "Cocoon",
    "type": "VC",
    "vietnamPresence": "REGION_ONLY",
    "vietnamEvidence": "",
    "website": "https://cocooncap.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "SAAS_B2B"
      ],
      "stages": [
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 50000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 150000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        }
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://cocooncap.com/apply_to_us/",
      "submitEmail": "",
      "ctaType": "apply",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư vòng pre-seed và seed tại Đông Nam Á, tập trung công nghệ doanh nghiệp và công nghệ lõi. Séc từ 500 nghìn tới 1,5 triệu USD.",
      "lookingFor": [],
      "tips": [
        "Quỹ công bố luôn đóng vai trò nhà đầu tư dẫn dắt. Nếu bạn đã có người dẫn khác thì có thể không phù hợp."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "BuyMed",
          "url": "",
          "whatTheyDo": "Sàn phân phối dược phẩm trực tuyến.",
          "industries": [
            "HEALTHTECH",
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Hiip",
          "url": "",
          "whatTheyDo": "Công nghệ tiếp thị qua người ảnh hưởng và thương mại điện tử.",
          "industries": [
            "MARTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Augmentus",
          "url": "",
          "whatTheyDo": "Lập trình robot công nghiệp không cần viết mã.",
          "industries": [
            "ROBOTICS"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Adravision",
          "url": "",
          "whatTheyDo": "Phần mềm quản lý phòng khám nha khoa.",
          "industries": [
            "HEALTHTECH",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "SensorFlow",
          "url": "",
          "whatTheyDo": "Quản lý tiêu thụ năng lượng cho khách sạn.",
          "industries": [
            "ENERGY",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Qashier",
          "url": "",
          "whatTheyDo": "Máy bán hàng và phần mềm vận hành cho hộ kinh doanh nhỏ.",
          "industries": [
            "RETAILTECH",
            "FINTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Lendela",
          "url": "",
          "whatTheyDo": "So sánh và kết nối khoản vay cá nhân một cách minh bạch.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "TruTrip",
          "url": "",
          "whatTheyDo": "Quản lý công tác phí và đặt vé cho doanh nghiệp châu Á.",
          "industries": [
            "SAAS_B2B",
            "TRAVEL"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Danh mục nghiêng hẳn về phần mềm doanh nghiệp và công nghệ sâu ở Singapore; chỉ hai doanh nghiệp Việt Nam được nêu. Mô tả lấy theo đúng cách quỹ ghi trên trang.",
      "source": "https://cocooncap.com/portfolio/",
      "verifiedAt": "2026-09-26"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://cocooncap.com/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức — phạm vi đầu tư và quy mô séc"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T09:06:59.582Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "cyberagent-capital",
    "slug": "cyberagent-capital",
    "name": "CyberAgent Capital",
    "shortName": "CyberAgent",
    "type": "CVC",
    "vietnamPresence": "INVESTED",
    "vietnamEvidence": "Danh mục đầu tư công bố trên trang chính thức có doanh nghiệp Việt Nam.",
    "website": "https://www.cyberagentcapital.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "ECOMMERCE",
        "FINTECH",
        "EDTECH",
        "GAMING"
      ],
      "stages": [
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN",
        "APAC"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.cyberagent.co.jp/form/id=310",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư của tập đoàn CyberAgent, tập trung vòng seed và giai đoạn sớm cho doanh nghiệp số tại châu Á, có danh mục tại Việt Nam.",
      "lookingFor": [],
      "tips": [
        "Quỹ nêu nguyên tắc thường tham gia với vai trò nhà đầu tư đầu tiên."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.cyberagentcapital.com/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        },
        {
          "url": "https://www.cyberagentcapital.com/portfolio/",
          "fetchedAt": "2026-09-11",
          "note": "Danh mục đầu tư có doanh nghiệp Việt Nam"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T09:11:03.299Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "do-ventures",
    "slug": "do-ventures",
    "name": "Do Ventures",
    "shortName": "Do Ventures",
    "type": "VC",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://doventures.vc",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "AI",
        "CLIMATE",
        "EDTECH",
        "HEALTHTECH",
        "FINTECH",
        "RETAILTECH",
        "MANUFACTURING",
        "ROBOTICS",
        "LOGISTICS"
      ],
      "stages": [],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://doventures.vc/en/contact",
      "submitEmail": "",
      "ctaType": "apply",
      "notes": "Trang liên hệ có nút \"Share your pitch deck\" kèm biểu mẫu tải deck lên."
    },
    "content": {
      "summary": "Quỹ đầu tư giai đoạn sớm, đầu tư vào công ty công nghệ tại Việt Nam và Đông Nam Á. Chiến lược xoay quanh hai nhóm ngành chính là công nghệ tiêu dùng và công nghệ sản xuất, trên nền tảng AI và khí hậu.",
      "lookingFor": [
        "Công nghệ tiêu dùng: giáo dục, y tế, dịch vụ tài chính, thương hiệu tiêu dùng thế hệ mới",
        "Công nghệ sản xuất: tự động hoá công nghiệp, chuỗi cung ứng bền vững, giải pháp nhà máy",
        "Công ty gốc AI và công ty ứng dụng AI trong hai nhóm ngành trên"
      ],
      "tips": [
        "Quỹ không công bố quy mô séc lẫn giai đoạn cụ thể trên trang chính thức. Hỏi thẳng trong buổi đầu thay vì đoán."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "Coolmate",
          "url": "https://www.coolmate.me",
          "whatTheyDo": "Thương hiệu thời trang nam bán thẳng tới người mua, không qua đại lý.",
          "industries": [
            "ECOMMERCE",
            "RETAILTECH"
          ],
          "stage": "LATER",
          "geo": "VN",
          "roundDate": "2024-10",
          "roundSize": {
            "amount": 600000000,
            "ccy": "USD",
            "fx": 26170,
            "fxDate": "2026-09-09"
          },
          "roundSource": "https://vir.com.vn/coolmate-wraps-up-6-million-series-b-funding-led-by-vertex-ventures-116900.html",
          "leadInvestor": false,
          "outcomeNote": ""
        },
        {
          "name": "Bizzi",
          "url": "https://bizzi.vn",
          "whatTheyDo": "Tự động đọc và đối chiếu hoá đơn đầu vào cho phòng kế toán doanh nghiệp.",
          "industries": [
            "SAAS_B2B",
            "AI"
          ],
          "stage": "SEED_PLUS",
          "geo": "VN",
          "roundDate": "2021-10",
          "roundSize": {
            "amount": 300000000,
            "ccy": "USD",
            "fx": 26170,
            "fxDate": "2026-09-09"
          },
          "roundSource": "https://vir.com.vn/bizzi-closes-3-million-pre-series-a-round-88283.html",
          "leadInvestor": false,
          "outcomeNote": ""
        },
        {
          "name": "VUIHOC",
          "url": "",
          "whatTheyDo": "Học trực tuyến bám chương trình phổ thông cho học sinh tiểu học và trung học.",
          "industries": [
            "EDTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "MFast",
          "url": "",
          "whatTheyDo": "Mạng lưới cộng tác viên phân phối sản phẩm tài chính tới vùng ngoài đô thị lớn.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Palexy",
          "url": "",
          "whatTheyDo": "Phân tích hành vi khách trong cửa hàng bằng camera và thị giác máy tính.",
          "industries": [
            "AI",
            "RETAILTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Finhay",
          "url": "",
          "whatTheyDo": "Ứng dụng tích luỹ và đầu tư số tiền nhỏ cho người trẻ.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Azota",
          "url": "",
          "whatTheyDo": "Công cụ giao bài và chấm bài trực tuyến cho giáo viên phổ thông.",
          "industries": [
            "EDTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Vinmake",
          "url": "",
          "whatTheyDo": "Kết nối đơn hàng của thương hiệu với các nhà máy gia công trong nước.",
          "industries": [
            "MANUFACTURING"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "",
      "source": "https://doventures.vc/portfolio",
      "verifiedAt": "2026-09-25"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://doventures.vc/en/about",
          "fetchedAt": "2026-09-09",
          "note": "Trang giới thiệu chính thức, mục Investment Strategy"
        }
      ],
      "lastVerifiedAt": "2026-09-09"
    },
    "updatedAt": "2026-09-27T08:55:14.381Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "febe-ventures",
    "slug": "febe-ventures",
    "name": "FEBE Ventures",
    "shortName": "FEBE",
    "type": "VC",
    "vietnamPresence": "INVESTED",
    "vietnamEvidence": "Quỹ nêu Việt Nam trong phạm vi hoạt động hoặc có thương vụ tại Việt Nam.",
    "website": "https://febe.vc",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "SAAS_B2B",
        "ECOMMERCE",
        "AI",
        "HEALTHTECH",
        "CLIMATE"
      ],
      "stages": [
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 25000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 75000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "PRESS",
        "confidence": "MEDIUM",
        "hardFilter": false,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://febe.vc/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư giai đoạn sớm tập trung vào doanh nghiệp gắn với Việt Nam.",
      "lookingFor": [],
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://theinvestor.vn/vietnam-focused-febe-ventures-announces-75-mln-second-fund-d7796.html",
          "fetchedAt": "2026-09-11",
          "note": "Bài báo về quỹ thứ hai"
        },
        {
          "url": "https://vietcetera.com/en/febe-ventures-initiates-75m-fund-ii-to-empower-global-startups",
          "fetchedAt": "2026-09-11",
          "note": "Bài báo về quỹ thứ hai"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-22T13:19:16.527Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "genai-fund",
    "slug": "genai-fund",
    "name": "GenAI Fund",
    "shortName": "GenAI Fund",
    "type": "VC",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://genaifund.ai",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "AI"
      ],
      "stages": [],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://genaifund.ai/#get-in-touch",
      "submitEmail": "",
      "notes": "Biểu mẫu \"Get in touch\" cuối trang chủ, quỹ đề nghị ghi kèm link pitch deck nếu đang gọi vốn. Ngoài ra quỹ thường gặp startup qua các chương trình ghép với doanh nghiệp (GenAI Open Innovation, FastTrack AI Accelerator)."
    },
    "content": {
      "summary": "Quỹ đầu tư mạo hiểm tập trung vào AI, đặt tại TP.HCM, đầu tư từ rất sớm vào công ty lấy AI làm lõi ở Đông Nam Á. Quỹ đồng thời vận hành các chương trình ghép startup với doanh nghiệp lớn để chạy thử nghiệm (PoC), nên con đường thường gặp là đi qua một chương trình doanh nghiệp trước khi được xét đầu tư.",
      "lookingFor": [
        "Công ty lấy AI làm lõi, bán cho doanh nghiệp (phần lớn danh mục là phần mềm B2B)",
        "Đội có thể chạy thử nghiệm với tập đoàn và chứng minh giá trị bằng số liệu"
      ],
      "tips": [
        "Quỹ có hai vai: đầu tư, và bán dịch vụ đổi mới sáng tạo cho doanh nghiệp (hackathon, ghép cặp, PoC, xây dựng startup cùng tập đoàn). Được chọn vào một chương trình doanh nghiệp không có nghĩa là đang được thẩm định đầu tư; hỏi rõ khi nào chuyển sang bàn chuyện vốn.",
        "Trang chính thức không công bố quy mô quỹ hay mức đầu tư mỗi khoản. Hỏi thẳng trong buổi đầu thay vì đoán.",
        "Một PoC có số liệu rõ với doanh nghiệp trong mạng lưới của quỹ là cách nói chuyện đầu tư thuyết phục nhất. Ví dụ: Bonbon thắng chương trình Wash3000 làm cùng Tasco rồi được quỹ cùng rót vòng pre-seed."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "Bonbon",
          "url": "https://bonbon.com.vn",
          "whatTheyDo": "Kết nối chủ xe với gara và dịch vụ chăm sóc xe; đội thắng chương trình Tasco Foundry Wash3000.",
          "industries": [
            "MOBILITY"
          ],
          "stage": "PRESEED",
          "geo": "VN",
          "roundDate": "2026-09",
          "roundSize": {
            "amount": 50000000,
            "ccy": "USD",
            "fx": 26170,
            "fxDate": "2026-09-09"
          },
          "roundSource": "https://genaifund.ai/2026/09/23/genai-fund-backs-bonbon-500k/",
          "leadInvestor": false,
          "outcomeNote": ""
        },
        {
          "name": "Arcanic AI",
          "url": "https://arcanic.ai",
          "whatTheyDo": "Giải pháp AI giúp doanh nghiệp và cơ quan nhà nước tự động hoá quy trình.",
          "industries": [
            "AI",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Tribee",
          "url": "https://tribee.io/en/",
          "whatTheyDo": "Nền tảng bán hàng cho đội tuyến đầu (tài chính, kênh truyền thống, bán lẻ, F&B), phân tích hành vi để huấn luyện nhân viên.",
          "industries": [
            "AI",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Presight",
          "url": "https://www.presight.io",
          "whatTheyDo": "Phân tích dữ liệu và tri thức nội bộ của doanh nghiệp, đưa ra gợi ý hành động.",
          "industries": [
            "AI",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Revve AI",
          "url": "https://www.revve.ai",
          "whatTheyDo": "Trợ lý AI bán hàng và chăm sóc khách hàng chạy liên tục qua giọng nói, chat, tin nhắn.",
          "industries": [
            "AI",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "LIFE AI",
          "url": "https://www.lifenetwork.ai",
          "whatTheyDo": "Kết hợp phòng thí nghiệm sinh học, trung tâm dữ liệu GPU và mô hình nền riêng để rút ngắn khám phá thuốc, y học chính xác.",
          "industries": [
            "AI",
            "HEALTHTECH",
            "BIOTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Blaze AI",
          "url": "https://blaze.vn",
          "whatTheyDo": "Nền tảng AI giọng nói cho Đông Nam Á: chuyển văn bản thành giọng nói, giọng nói thành văn bản, tách người nói.",
          "industries": [
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Shieldbase (Malaysia)",
          "url": "https://shieldbase.ai",
          "whatTheyDo": "Hệ điều hành AI nối dữ liệu rời rạc từ công cụ AI và hệ thống cũ thành quy trình tự động.",
          "industries": [
            "AI",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Fortii (Malaysia)",
          "url": "https://www.fortii.ai",
          "whatTheyDo": "Quản trị và bảo mật dữ liệu, AI; quyền riêng tư và kiểm soát tuân thủ.",
          "industries": [
            "AI",
            "CYBERSECURITY"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "ourteam (Malaysia)",
          "url": "https://ourteam.ai",
          "whatTheyDo": "AI tuyển dụng, sàng lọc toàn bộ ứng viên cho doanh nghiệp.",
          "industries": [
            "AI",
            "HRTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Superagent (Thái Lan)",
          "url": "",
          "whatTheyDo": "Môi giới bất động sản vận hành bằng AI cho chủ đầu tư và chủ nhà.",
          "industries": [
            "AI",
            "PROPTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "",
      "source": "https://genaifund.ai/our-portfolio/",
      "verifiedAt": "2026-10-13"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://genaifund.ai/",
          "fetchedAt": "2026-10-13",
          "note": "Trang chính thức: luận điểm đầu tư, kênh liên hệ, chương trình"
        },
        {
          "url": "https://genaifund.ai/our-portfolio/",
          "fetchedAt": "2026-10-13",
          "note": "Danh mục đầu tư"
        },
        {
          "url": "https://genaifund.ai/2026/09/23/genai-fund-backs-bonbon-500k/",
          "fetchedAt": "2026-10-13",
          "note": "Khoản đầu tư Bonbon, vòng pre-seed 500.000 USD do Tasco dẫn dắt"
        },
        {
          "url": "https://beyondpilot.ai/programs/nestle-vietnam-ai-reinvention",
          "fetchedAt": "2026-10-13",
          "note": "Chương trình Nestlé Vietnam AI Reinvention do quỹ vận hành"
        }
      ],
      "lastVerifiedAt": "2026-10-13"
    },
    "updatedAt": "",
    "updatedBy": ""
  },
  {
    "fundId": "genesia-ventures",
    "slug": "genesia-ventures",
    "name": "Genesia Ventures",
    "shortName": "Genesia",
    "type": "VC",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://www.genesiaventures.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.genesiaventures.com/en/contact-en/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": "Trang liên hệ chính thức, có biểu mẫu."
    },
    "content": {
      "summary": "Quỹ đầu tư độc lập đặt tại Tokyo, chuyên vòng pre-seed và seed cho startup công nghệ số tại châu Á. Có văn phòng tại TP.HCM và đã đầu tư vào nhiều doanh nghiệp Việt Nam.",
      "lookingFor": [
        "Startup công nghệ số ở giai đoạn pre-seed tới seed",
        "Quỹ không giới hạn ngành cụ thể, nhấn mạnh chuyển đổi số và ngành bền vững"
      ],
      "tips": [
        "Quỹ không công bố quy mô séc trên trang chính thức. Hỏi thẳng trong buổi đầu.",
        "Có mặt tại Việt Nam từ sớm nên hiểu bối cảnh trong nước hơn phần lớn quỹ khu vực."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "Fundiin",
          "url": "",
          "whatTheyDo": "Dịch vụ mua trước trả sau cho thương mại điện tử và bán lẻ.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Kamereo",
          "url": "",
          "whatTheyDo": "Bán sỉ nguyên liệu thực phẩm cho nhà hàng, quán ăn và doanh nghiệp.",
          "industries": [
            "FOODBEV",
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "BuyMed",
          "url": "",
          "whatTheyDo": "Sàn đặt hàng dược phẩm cho nhà thuốc.",
          "industries": [
            "HEALTHTECH",
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Selly",
          "url": "",
          "whatTheyDo": "Bán hàng qua mạng lưới cộng tác viên trên mạng xã hội.",
          "industries": [
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Rootopia",
          "url": "",
          "whatTheyDo": "Tài chính cho giáo dục, bắt đầu từ dịch vụ cho vay học phí.",
          "industries": [
            "FINTECH",
            "EDTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "eDoctor",
          "url": "",
          "whatTheyDo": "Khám sức khoẻ cho cá nhân và cho nhân viên doanh nghiệp.",
          "industries": [
            "HEALTHTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "MVillage",
          "url": "",
          "whatTheyDo": "Chuỗi chỗ ở cho thuê dài ngày trong đô thị.",
          "industries": [
            "PROPTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Manabie",
          "url": "",
          "whatTheyDo": "Học trực tuyến kết hợp lớp học trực tiếp cho học sinh phổ thông.",
          "industries": [
            "EDTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Mô tả từng doanh nghiệp lấy theo đúng cách quỹ ghi trên trang danh mục.",
      "source": "https://www.genesiaventures.com/en/partners/",
      "verifiedAt": "2026-09-24"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.genesiaventures.com/en/top-en/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ bản tiếng Anh, mục STAGE và INVESTMENT"
        },
        {
          "url": "https://www.genesiaventures.com/en/4thfund-finalclose-eng/",
          "fetchedAt": "2026-09-11",
          "note": "Thông cáo quỹ thứ tư, nêu rõ tập trung vòng seed và các văn phòng"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T09:08:40.359Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "golden-gate-ventures",
    "slug": "golden-gate-ventures",
    "name": "Golden Gate Ventures",
    "shortName": "Golden Gate",
    "type": "VC",
    "vietnamPresence": "REGION_ONLY",
    "vietnamEvidence": "",
    "website": "https://www.goldengate.vc",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [],
      "geos": [
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": null,
      "submitEmail": "hello@goldengate.vc",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư giai đoạn sớm tại Đông Nam Á. Trang chính thức không tách rõ từng bậc vòng gọi vốn cũng như quy mô séc.",
      "lookingFor": [],
      "tips": [
        "Quỹ không công bố giai đoạn cụ thể lẫn quy mô séc. Hỏi thẳng trong buổi đầu."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "Loship",
          "url": "",
          "whatTheyDo": "Giao đồ ăn và hàng hoá nội thành trong vòng một giờ.",
          "industries": [
            "LOGISTICS",
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Chợ Tốt",
          "url": "",
          "whatTheyDo": "Sàn rao vặt mua bán đồ đã qua sử dụng.",
          "industries": [
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Appota",
          "url": "",
          "whatTheyDo": "Phát hành game di động và thanh toán số cho người chơi.",
          "industries": [
            "GAMING",
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Tititada",
          "url": "",
          "whatTheyDo": "Ứng dụng đầu tư chứng khoán cho nhà đầu tư cá nhân mới bắt đầu.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Mio",
          "url": "",
          "whatTheyDo": "Mạng lưới bán hàng theo nhóm ở khu vực ngoài đô thị lớn.",
          "industries": [
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Bảo Kim",
          "url": "",
          "whatTheyDo": "Cổng thanh toán trực tuyến và dịch vụ tài chính cho doanh nghiệp.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Vui",
          "url": "",
          "whatTheyDo": "Ứng dụng cho người lao động nhận phần lương đã làm trước kỳ trả lương.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Ninja Van",
          "url": "",
          "whatTheyDo": "Giao hàng chặng cuối cho thương mại điện tử khắp Đông Nam Á.",
          "industries": [
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Danh mục của quỹ trải khắp Đông Nam Á; ở đây chỉ liệt kê những doanh nghiệp quỹ ghi rõ có hoạt động tại Việt Nam.",
      "source": "https://www.goldengate.vc/portfolio",
      "verifiedAt": "2026-09-24"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.goldengate.vc/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T08:55:29.034Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "hcm-vif",
    "slug": "hcm-vif",
    "name": "Quỹ đầu tư mạo hiểm TP. Hồ Chí Minh (HCM VIF)",
    "shortName": "HCM VIF",
    "type": "GOV",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://hcmc.vc",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "AI",
        "SEMICONDUCTOR",
        "BIOTECH",
        "MATERIALS",
        "ENERGY"
      ],
      "stages": [
        "PRESEED",
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN-HCM",
        "VN"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": [
        {
          "code": "DIA_BAN_HCM",
          "field": "identity.city",
          "op": "in",
          "value": [
            "HCM"
          ],
          "label": "Ưu tiên doanh nghiệp hoạt động tại TP. Hồ Chí Minh"
        }
      ]
    },
    "process": {
      "submitUrl": "https://hcmc.vc/danh-cho-startup/gui-ho-so",
      "submitEmail": "",
      "ctaType": "apply",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư mạo hiểm của TP. Hồ Chí Minh, hướng vào doanh nghiệp đổi mới sáng tạo trong các nhóm công nghệ chiến lược.",
      "lookingFor": [],
      "tips": [
        "Quỹ nhà nước thường có quy trình và yêu cầu hồ sơ khác quỹ tư nhân. Quỹ đã có kênh nộp hồ sơ chính thức qua Website tuy nhiên hiện chưa có thương vụ thể để đối chiếu mẫu."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://dost.hochiminhcity.gov.vn/",
          "fetchedAt": "2026-09-11",
          "note": "Sở Khoa học và Công nghệ TP.HCM"
        },
        {
          "url": "https://hcmc.vc",
          "fetchedAt": "2026-09-21",
          "note": "Quỹ đầu tư mạo hiểm Tp. Hồ Chí Minh"
        }
      ],
      "lastVerifiedAt": "2026-09-21"
    },
    "updatedAt": "2026-09-20T21:53:40.461Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "insignia-ventures-partners",
    "slug": "insignia-ventures-partners",
    "name": "Insignia Ventures Partners",
    "shortName": "Insignia",
    "type": "VC",
    "vietnamPresence": "REGION_ONLY",
    "vietnamEvidence": "",
    "website": "https://www.insignia.vc",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "SEED",
        "SERIES_A",
        "LATER"
      ],
      "geos": [
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 10000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 500000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "THIRD_PARTY_ESTIMATE",
        "confidence": "LOW",
        "hardFilter": false,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.insignia.vc/pitch",
      "submitEmail": "",
      "ctaType": "apply",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư công nghệ tại Đông Nam Á.",
      "lookingFor": [],
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.insignia.vc/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-27T09:09:46.944Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "iterative",
    "slug": "iterative",
    "name": "Iterative",
    "shortName": "Iterative",
    "type": "ACCELERATOR",
    "vietnamPresence": "REGION_ONLY",
    "vietnamEvidence": "",
    "website": "https://www.iterative.vc",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "IDEA",
        "PROTOTYPE",
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 15000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 50000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        }
      },
      "hardRequirements": [
        {
          "code": "TOAN_THOI_GIAN",
          "field": "team.founders",
          "op": "someTrue",
          "field2": "fullTime",
          "label": "Người sáng lập phải làm toàn thời gian cho doanh nghiệp"
        }
      ]
    },
    "process": {
      "submitUrl": "https://www.iterative.vc/apply",
      "submitEmail": "",
      "ctaType": "apply",
      "notes": ""
    },
    "content": {
      "summary": "Chương trình tăng tốc tại Đông Nam Á, đầu tư 150 nghìn tới 500 nghìn USD qua SAFE post-money đổi khoảng 10 tới 15 phần trăm cổ phần.",
      "lookingFor": [],
      "tips": [
        "Bắt buộc tham gia chương trình và người sáng lập phải làm toàn thời gian.",
        "Doanh nghiệp phải đặt tại Đông Nam Á hoặc có phần lớn khách hàng trong khu vực."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.iterative.vc/frequently-asked-questions",
          "fetchedAt": "2026-09-11",
          "note": "Trang hỏi đáp — quy mô đầu tư và điều kiện"
        },
        {
          "url": "https://www.iterative.vc/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-20T14:40:33.202Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "january-capital",
    "slug": "january-capital",
    "name": "January Capital",
    "shortName": "January Capital",
    "type": "VC",
    "vietnamPresence": "INVESTED",
    "vietnamEvidence": "Quỹ nêu Việt Nam trong phạm vi hoạt động hoặc có thương vụ tại Việt Nam.",
    "website": "https://www.january.capital",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "ECOMMERCE",
        "FINTECH",
        "HEALTHTECH",
        "ENERGY",
        "AGRITECH",
        "AI",
        "SAAS_B2B"
      ],
      "stages": [
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "VN",
        "APAC"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 50000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 200000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "OFFICIAL",
        "confidence": "HIGH",
        "hardFilter": true,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.january.capital/contact",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư công nghệ tại châu Á Thái Bình Dương, hướng tới là nhà đầu tư thể chế đầu tiên của doanh nghiệp.",
      "lookingFor": [],
      "tips": []
    },
    "portfolio": {
      "items": [
        {
          "name": "Aemi",
          "url": "",
          "whatTheyDo": "Công cụ vận hành và chuỗi cung ứng số cho ngành chăm sóc sức khoẻ, làm đẹp.",
          "industries": [
            "ECOMMERCE",
            "SAAS_B2B"
          ],
          "stage": "SEED",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Inflow",
          "url": "",
          "whatTheyDo": "Chuỗi cung ứng thời trang với sản xuất theo yêu cầu.",
          "industries": [
            "MANUFACTURING",
            "ECOMMERCE"
          ],
          "stage": "SEED",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Qode",
          "url": "",
          "whatTheyDo": "Tinh gọn tuyển dụng cho các tổ chức thiên về công nghệ.",
          "industries": [
            "HRTECH",
            "AI"
          ],
          "stage": "SEED",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "CoLearn",
          "url": "",
          "whatTheyDo": "Học trực tuyến cho học sinh phổ thông tại Indonesia.",
          "industries": [
            "EDTECH"
          ],
          "stage": "SEED",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Akulaku",
          "url": "",
          "whatTheyDo": "Cho vay tiêu dùng và mua trước trả sau tại Indonesia.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "aCommerce",
          "url": "",
          "whatTheyDo": "Vận hành thương mại điện tử thuê ngoài cho các thương hiệu.",
          "industries": [
            "ECOMMERCE",
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Omni HR",
          "url": "",
          "whatTheyDo": "Phần mềm quản trị nhân sự cho doanh nghiệp Đông Nam Á.",
          "industries": [
            "HRTECH",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Go1",
          "url": "",
          "whatTheyDo": "Kho khoá học trực tuyến cho doanh nghiệp đào tạo nhân viên.",
          "industries": [
            "EDTECH",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "GLOBAL",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Mô tả lấy theo đúng cách quỹ ghi trên trang danh mục.",
      "source": "https://www.january.capital/portfolio",
      "verifiedAt": "2026-09-26"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.january.capital/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        },
        {
          "url": "https://www.january.capital/portfolio",
          "fetchedAt": "2026-09-11",
          "note": "Danh mục đầu tư"
        },
        {
          "url": "https://www.january.capital/",
          "fetchedAt": "2026-09-11",
          "note": "Quỹ công bố khoản đầu tư ban đầu 0,5–2 triệu USD; hơn 75% thương vụ ở vòng vốn tổ chức đầu tiên"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-27T08:55:34.491Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "jenfi",
    "slug": "jenfi",
    "name": "Jenfi",
    "shortName": "Jenfi",
    "type": "LENDER",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://jenfi.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "DEBT"
      ],
      "industries": [
        "ECOMMERCE",
        "SAAS_B2B",
        "RETAILTECH"
      ],
      "stages": [],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 1000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 100000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "PRESS",
        "confidence": "MEDIUM",
        "hardFilter": false,
        "verifiedAt": "2026-09-15"
      },
      "requiresRevenue": true,
      "hardRequirements": [
        {
          "code": "SAU_THANG_DOANH_THU",
          "field": "finance.monthsOfRevenue",
          "op": "gte",
          "value": 6,
          "label": "Có ít nhất 6 tháng doanh thu kiểm chứng được"
        }
      ]
    },
    "process": {
      "submitUrl": "https://jenfi.com/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": "Cần xác minh hạn mức và điều kiện pháp nhân áp dụng tại Việt Nam."
    },
    "content": {
      "summary": "Đơn vị cấp vốn hoàn trả theo doanh thu cho doanh nghiệp số đã có dòng tiền. Không lấy cổ phần, hoàn trả theo tỷ lệ phần trăm doanh thu hàng tháng.",
      "lookingFor": [],
      "tips": [
        "Đây là vốn phải hoàn trả, không phải tài trợ. Chi phí vốn cần so sánh kỹ với vay ngân hàng trước khi quyết định."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://jenfi.com/",
          "fetchedAt": "2026-09-12",
          "note": "Trang chính thức — sản phẩm và quy trình"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-20T14:38:24.014Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "kk-fund",
    "slug": "kk-fund",
    "name": "KK Fund",
    "shortName": "KK Fund",
    "type": "VC",
    "vietnamPresence": "INVESTED",
    "vietnamEvidence": "Quỹ nêu Việt Nam trong phạm vi hoạt động hoặc có thương vụ tại Việt Nam.",
    "website": "https://kkfund.co",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "FINTECH",
        "EDTECH",
        "HRTECH",
        "MOBILITY",
        "HEALTHTECH",
        "PROPTECH",
        "WEB3",
        "MEDIA"
      ],
      "stages": [
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 40000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 50000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "OFFICIAL_STALE",
        "confidence": "LOW",
        "hardFilter": false,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": null,
      "submitEmail": "info@kkfund.co",
      "notes": "Quỹ nhận hồ sơ qua email; không có biểu mẫu nộp trực tuyến."
    },
    "content": {
      "summary": "Quỹ đầu tư giai đoạn sớm cho doanh nghiệp công nghệ tại Đông Nam Á và Đông Á.",
      "lookingFor": [],
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://kkfund.co/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức — luận điểm đầu tư"
        },
        {
          "url": "https://kkfund.co/portfolio/",
          "fetchedAt": "2026-09-11",
          "note": "Danh mục đầu tư"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-20T14:29:44.966Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "mekong-capital",
    "slug": "mekong-capital",
    "name": "Mekong Capital",
    "shortName": "Mekong Capital",
    "type": "PE_GROWTH",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://www.mekongcapital.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "RETAILTECH",
        "FOODBEV",
        "HEALTHTECH",
        "EDTECH",
        "BIOTECH",
        "AGRITECH"
      ],
      "stages": [
        "LATER"
      ],
      "geos": [
        "VN"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 500000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 2000000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "OBSERVED_DEALS",
        "sourceType": "PRESS",
        "confidence": "LOW",
        "hardFilter": false,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.mekongcapital.com/contact-us/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư tăng trưởng tại Việt Nam, mua cổ phần thiểu số lớn ở doanh nghiệp đã có quy mô.",
      "lookingFor": [],
      "tips": []
    },
    "portfolio": {
      "items": [
        {
          "name": "Thế Giới Di Động",
          "url": "",
          "whatTheyDo": "Chuỗi bán lẻ điện thoại và điện máy.",
          "industries": [
            "RETAILTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2007-05",
          "outcome": "EXITED",
          "outcomeNote": "Đầu tư 5/2007, thoái vốn 1/2018."
        },
        {
          "name": "Golden Gate",
          "url": "",
          "whatTheyDo": "Chuỗi nhà hàng lẩu nướng (Kichi-Kichi, Gogi House, Ashima).",
          "industries": [
            "FOODBEV"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2008-04",
          "outcome": "EXITED",
          "outcomeNote": "Đầu tư 4/2008, bán lại cổ phần 8/2014."
        },
        {
          "name": "Pizza 4P's",
          "url": "",
          "whatTheyDo": "Chuỗi nhà hàng pizza tự làm phô mai tại Việt Nam.",
          "industries": [
            "FOODBEV"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcome": "EXITED",
          "outcomeNote": "Thoái vốn năm 2022."
        },
        {
          "name": "F88",
          "url": "",
          "whatTheyDo": "Chuỗi cửa hàng cho vay có tài sản bảo đảm.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Gene Solutions",
          "url": "",
          "whatTheyDo": "Xét nghiệm gen phát hiện sớm bệnh lý.",
          "industries": [
            "HEALTHTECH",
            "BIOTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Pharmacity",
          "url": "",
          "whatTheyDo": "Chuỗi nhà thuốc bán lẻ.",
          "industries": [
            "HEALTHTECH",
            "RETAILTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Marou",
          "url": "",
          "whatTheyDo": "Sô cô la thủ công làm từ hạt ca cao trồng trong nước.",
          "industries": [
            "FOODBEV"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Vua Nệm",
          "url": "",
          "whatTheyDo": "Chuỗi bán lẻ nệm và đồ ngủ.",
          "industries": [
            "RETAILTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Quỹ không công bố số tiền của từng khoản đầu tư.",
      "source": "https://www.mekongcapital.com/our-investments/",
      "verifiedAt": "2026-09-25"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.mekongcapital.com/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-27T08:55:33.191Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "monks-hill-ventures",
    "slug": "monks-hill-ventures",
    "name": "Monk’s Hill Ventures",
    "shortName": "Monk’s Hill",
    "type": "VC",
    "vietnamPresence": "REGION_ONLY",
    "vietnamEvidence": "",
    "website": "https://www.monkshill.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "SERIES_A",
        "LATER"
      ],
      "geos": [
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.monkshill.com/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư công nghệ tại Đông Nam Á.",
      "lookingFor": [],
      "tips": []
    },
    "portfolio": {
      "items": [
        {
          "name": "1Long",
          "url": "",
          "whatTheyDo": "Ứng dụng tích luỹ và đầu tư số tiền nhỏ cho người mới bắt đầu.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Saladin",
          "url": "",
          "whatTheyDo": "Nền tảng so sánh và phân phối bảo hiểm trực tuyến.",
          "industries": [
            "INSURTECH",
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Vucar",
          "url": "",
          "whatTheyDo": "Thu mua và bán lại ô tô cũ, kiểm định trước khi bán.",
          "industries": [
            "ECOMMERCE",
            "MOBILITY"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "INKR",
          "url": "",
          "whatTheyDo": "Nền tảng đọc và dịch truyện tranh có bản quyền.",
          "industries": [
            "MEDIA"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "ELSA",
          "url": "",
          "whatTheyDo": "Ứng dụng luyện phát âm tiếng Anh bằng nhận dạng giọng nói.",
          "industries": [
            "EDTECH",
            "AI"
          ],
          "stage": "",
          "geo": "GLOBAL",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Glints",
          "url": "",
          "whatTheyDo": "Nền tảng tuyển dụng và quản lý nhân sự cho doanh nghiệp Đông Nam Á.",
          "industries": [
            "HRTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Jenfi",
          "url": "",
          "whatTheyDo": "Cấp vốn hoàn trả theo doanh thu cho doanh nghiệp bán hàng trực tuyến.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Ninja Van",
          "url": "",
          "whatTheyDo": "Giao hàng chặng cuối cho thương mại điện tử khắp Đông Nam Á.",
          "industries": [
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Quỹ không công bố số tiền của từng thương vụ.",
      "source": "https://www.monkshill.com/portfolio",
      "verifiedAt": "2026-09-24"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.monkshill.com/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-27T08:55:31.695Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "patamar-capital",
    "slug": "patamar-capital",
    "name": "Patamar Capital",
    "shortName": "Patamar",
    "type": "IMPACT_VC",
    "vietnamPresence": "INVESTED",
    "vietnamEvidence": "Quỹ nêu Việt Nam trong phạm vi hoạt động và có thương vụ tại đây.",
    "website": "https://patamar.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "FINTECH",
        "CLIMATE",
        "HEALTHTECH",
        "EDTECH",
        "AGRITECH",
        "SAAS_B2B"
      ],
      "stages": [
        "SEED",
        "SERIES_A",
        "LATER"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://patamar.com/contact/",
      "submitEmail": "",
      "ctaType": "apply",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư tác động tại Đông Nam Á, nhắm vào mô hình phục vụ nhóm dân cư ít được tiếp cận dịch vụ và các giải pháp khí hậu.",
      "lookingFor": [],
      "tips": [
        "Mô hình phải chứng minh được tác động đo lường được, không chỉ tiềm năng tài chính.",
        "Quỹ dùng nhiều hình thức gồm cổ phần và cho vay — hỏi rõ hình thức áp dụng cho trường hợp của bạn."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "Vigo",
          "url": "",
          "whatTheyDo": "Phân phối hàng tiêu dùng B2B không cần kho, dựa trên bán hàng qua mạng xã hội.",
          "industries": [
            "ECOMMERCE",
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Saladin",
          "url": "",
          "whatTheyDo": "Giải pháp mua bảo hiểm và bồi thường trực tuyến.",
          "industries": [
            "INSURTECH",
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "SwipeRX",
          "url": "",
          "whatTheyDo": "Kết nối dược sĩ và nhà thuốc độc lập trong khu vực.",
          "industries": [
            "HEALTHTECH",
            "SAAS_B2B"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Kinara Capital",
          "url": "",
          "whatTheyDo": "Cho vay vốn lưu động cho doanh nghiệp nhỏ và vừa tại Ấn Độ.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "APAC",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Mapan",
          "url": "",
          "whatTheyDo": "Phân phối hàng hoá tới người tiêu dùng thu nhập thấp qua nền tảng công nghệ.",
          "industries": [
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Bababos",
          "url": "",
          "whatTheyDo": "Chuỗi cung ứng vật liệu xây dựng B2B kèm điều khoản trả chậm.",
          "industries": [
            "ECOMMERCE",
            "FINTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "FishLog",
          "url": "",
          "whatTheyDo": "Tinh gọn chuỗi cung ứng thuỷ sản tại Indonesia.",
          "industries": [
            "AGRITECH",
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Ayoconnect",
          "url": "",
          "whatTheyDo": "Hạ tầng kết nối nền tảng công nghệ với nhà cung cấp dịch vụ thanh toán hoá đơn.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Quỹ đầu tư theo hướng tài chính bao trùm và sinh kế cho nhóm thu nhập thấp ở các thị trường mới nổi. Mô tả lấy theo đúng cách quỹ ghi trên trang.",
      "source": "https://patamar.com/portfolio/",
      "verifiedAt": "2026-09-26"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://patamar.com/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức — luận điểm đầu tư"
        },
        {
          "url": "https://patamar.com/contact/",
          "fetchedAt": "2026-09-11",
          "note": "Kênh liên hệ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T08:55:30.367Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "quest-ventures",
    "slug": "quest-ventures",
    "name": "Quest Ventures",
    "shortName": "Quest",
    "type": "VC",
    "vietnamPresence": "REGION_ONLY",
    "vietnamEvidence": "",
    "website": "https://www.questventures.com",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "AI",
        "ECOMMERCE",
        "FINTECH",
        "FOODBEV",
        "INSURTECH",
        "LOGISTICS",
        "MEDIA",
        "PROPTECH",
        "GAMING"
      ],
      "stages": [
        "PRESEED",
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN",
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 25000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 200000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "THIRD_PARTY_ESTIMATE",
        "confidence": "LOW",
        "hardFilter": false,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.questventures.com/contact/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": ""
    },
    "content": {
      "summary": "Nền tảng đầu tư tại châu Á vận hành nhiều quỹ và chương trình khác nhau.",
      "lookingFor": [],
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.questventures.com/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-22T13:20:59.742Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "smedf",
    "slug": "smedf",
    "name": "Quỹ Phát triển doanh nghiệp nhỏ và vừa (SMEDF)",
    "shortName": "SMEDF",
    "type": "GOV",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://www.smedf.gov.vn",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "DEBT"
      ],
      "industries": [],
      "stages": [],
      "geos": [
        "VN"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "requiresIncorporation": true,
      "hardRequirements": [
        {
          "code": "LA_DNNVV",
          "field": "identity.entityType",
          "op": "in",
          "value": [
            "LLC1",
            "LLC2",
            "JSC"
          ],
          "label": "Phải là doanh nghiệp nhỏ và vừa đủ điều kiện theo quy định"
        }
      ]
    },
    "process": {
      "submitUrl": "https://www.smedf.gov.vn/",
      "submitEmail": "",
      "ctaType": "contact",
      "notes": "Cho vay trực tiếp hoặc uỷ thác qua ngân hàng đối tác."
    },
    "content": {
      "summary": "Quỹ nhà nước cho doanh nghiệp nhỏ và vừa vay với lãi suất ưu đãi, tối đa 80% tổng vốn đầu tư của dự án. Không lấy cổ phần.",
      "lookingFor": [
        "Doanh nghiệp nhỏ và vừa có phương án kinh doanh khả thi",
        "Có vốn đối ứng cho phần còn lại của dự án"
      ],
      "tips": [
        "Đây là khoản vay phải hoàn trả, có thẩm định tín dụng và thường cần tài sản bảo đảm — khác hẳn tài trợ không hoàn lại.",
        "Lãi suất và danh sách ngân hàng nhận uỷ thác thay đổi theo công bố từng thời kỳ, nên kiểm tra lại trên trang quỹ trước khi lập kế hoạch."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.smedf.gov.vn/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chính thức của quỹ"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-20T14:34:50.251Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "thinkzone-gmf1",
    "slug": "thinkzone-global-minds-fund-i",
    "name": "ThinkZone — Global Minds Fund I",
    "shortName": "ThinkZone GMF I",
    "type": "VC",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://www.thinkzone.vn",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "PRESEED",
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": null,
        "max": {
          "amount": 100000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "OFFICIAL",
        "confidence": "HIGH",
        "hardFilter": true,
        "verifiedAt": "2026-09-15"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://xfv1phagnc8.sg.larksuite.com/share/base/form/shrlgRP9afVQk68SCcNtLUT3eVg",
      "submitEmail": "",
      "ctaType": "apply",
      "notes": "Nộp hồ sơ qua biểu mẫu trực tuyến của quỹ."
    },
    "content": {
      "summary": "Quỹ đầu tư giai đoạn sớm đặt tại Hà Nội, đầu tư vào startup công nghệ tại Việt Nam từ vòng pre-seed tới Series A, quy mô séc tới 3 triệu USD. Đầu tư bằng đồng Việt Nam theo khuôn khổ Nghị định 38/2018.",
      "lookingFor": [
        "Startup công nghệ đa ngành tại thị trường Việt Nam",
        "Quỹ có chương trình tăng tốc riêng cho giai đoạn rất sớm"
      ],
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.thinkzone.vn/",
          "fetchedAt": "2026-09-15",
          "note": "Global Minds Fund I: pre-seed đến Series A, tối đa 1 triệu USD mỗi công ty"
        },
        {
          "url": "https://xfv1phagnc8.sg.larksuite.com/share/base/form/shrlgRP9afVQk68SCcNtLUT3eVg",
          "fetchedAt": "2026-09-15",
          "note": "Biểu mẫu nộp hồ sơ do quỹ công bố"
        },
        {
          "url": "https://www.thinkzone.vn/blog/the-inside-story-of-thinkzone-fund-ii",
          "fetchedAt": "2026-09-09",
          "note": "Bài trên blog chính thức, nêu giai đoạn và quy mô séc của Fund II"
        }
      ],
      "lastVerifiedAt": "2026-09-15"
    },
    "updatedAt": "2026-09-22T13:21:15.946Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "tin-men-capital",
    "slug": "tin-men-capital",
    "name": "Tin Men Capital",
    "shortName": "Tin Men Capital",
    "type": "VC",
    "vietnamPresence": "REGION_ONLY",
    "vietnamEvidence": "",
    "website": "https://www.tinmen.asia",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "SAAS_B2B",
        "MANUFACTURING",
        "LOGISTICS",
        "AGRITECH",
        "PROPTECH"
      ],
      "stages": [],
      "geos": [
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [
        "B2B"
      ],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.tinmen.asia/contact/founders",
      "submitEmail": "startups@tinmen.asia",
      "notes": "Biểu mẫu \"Pitch to us\" trên trang chính thức; nếu biểu mẫu lỗi, gửi email startups@tinmen.asia."
    },
    "content": {
      "summary": "Quỹ đầu tư mạo hiểm tại Singapore, chỉ đầu tư vào công ty công nghệ B2B ở Đông Nam Á: phần mềm doanh nghiệp và sàn B2B cho các ngành truyền thống như sản xuất, logistics, xây dựng, hàng hải, nông nghiệp, bất động sản. Chỉ đầu tư vào công ty đã có doanh thu đáng kể, và luôn dẫn dắt vòng khi rót séc đầu tiên.",
      "lookingFor": [
        "Công ty B2B đã có doanh thu đáng kể, không nhận giai đoạn ý tưởng",
        "Phần mềm doanh nghiệp hoặc sàn B2B cho ngành truyền thống ở Đông Nam Á"
      ],
      "tips": [
        "Séc đầu tiên từ vài trăm nghìn USD cho công ty giai đoạn sớm tới vài triệu USD cho công ty đi xa hơn, theo trang nhận hồ sơ chính thức.",
        "Quỹ chỉ đầu tư khi được dẫn dắt vòng. Nếu vòng của bạn đã có nhà đầu tư dẫn dắt, nhiều khả năng không phù hợp.",
        "Công ty đặt trụ sở ngoài Đông Nam Á được yêu cầu chuyển trụ sở về khu vực, thường là Singapore. Startup Việt Nam nên hỏi sớm liệu có phải dựng pháp nhân Singapore không.",
        "Chưa thấy công ty Việt Nam trong danh mục công khai. Đây là quỹ khu vực, hãy hỏi kinh nghiệm của họ với thị trường Việt Nam."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.tinmen.asia/",
          "fetchedAt": "2026-10-14",
          "note": "Trang chính thức: chỉ đầu tư B2B tại Đông Nam Á"
        },
        {
          "url": "https://www.tinmen.asia/contact/founders",
          "fetchedAt": "2026-10-14",
          "note": "Tiêu chí, mức séc đầu tiên, cách nộp hồ sơ"
        },
        {
          "url": "https://www.tinmen.asia/portfolio",
          "fetchedAt": "2026-10-14",
          "note": "Danh mục (các công ty trang 1 đều đã thoái vốn)"
        }
      ],
      "lastVerifiedAt": "2026-10-14"
    },
    "updatedAt": "",
    "updatedBy": ""
  },
  {
    "fundId": "touchstone-partners",
    "slug": "touchstone-partners",
    "name": "Touchstone Partners",
    "shortName": "Touchstone",
    "type": "VC",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://touchstone.vc",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [],
      "geos": [
        "VN"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 20000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": {
          "amount": 100000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        }
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://touchstone.vc/contact-us",
      "submitEmail": "hello@touchstone.vc",
      "ctaType": "apply",
      "notes": "Trang có nút \"Pitch Us\" dẫn tới biểu mẫu liên hệ."
    },
    "content": {
      "summary": "Quỹ đầu tư mạo hiểm đặt tại TP.HCM, đầu tư vào startup công nghệ giai đoạn sớm tại Việt Nam, séc từ 200 nghìn tới 1 triệu USD. Quỹ nhấn mạnh tiêu chí tác động xã hội và môi trường bên cạnh khả năng sinh lời.",
      "lookingFor": [
        "Startup công nghệ giải quyết vấn đề nền tảng của Việt Nam",
        "Người sáng lập có năng lực và chính trực — quỹ nêu rõ đây là tiêu chí hàng đầu"
      ],
      "tips": [
        "Quỹ tự đặt câu hỏi \"nếu startup này thành công thì tạo ra khác biệt gì cho Việt Nam\". Hồ sơ nên trả lời được câu đó một cách cụ thể.",
        "Các lĩnh vực tác động quỹ công bố gồm y tế, tiểu thương, giáo dục, nông nghiệp và giảm phát thải."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "Selex Motors",
          "url": "",
          "whatTheyDo": "Xe máy điện chở hàng kèm mạng lưới trạm đổi pin cho tài xế giao hàng.",
          "industries": [
            "MOBILITY",
            "CLIMATE"
          ],
          "stage": "SEED",
          "geo": "VN",
          "roundDate": "2022-01",
          "roundSize": {
            "amount": 210000000,
            "ccy": "USD",
            "fx": 26170,
            "fxDate": "2026-09-09"
          },
          "roundSource": "https://e27.co/vietnams-ev-startup-selex-motors-banks-us2-1m-touchstone-partners-20220120/",
          "leadInvestor": true,
          "outcomeNote": ""
        },
        {
          "name": "Prep",
          "url": "",
          "whatTheyDo": "Nền tảng luyện thi ngoại ngữ trực tuyến có chấm chữa tự động.",
          "industries": [
            "EDTECH",
            "AI"
          ],
          "stage": "SERIES_A",
          "geo": "VN",
          "roundDate": "2024-05",
          "roundSize": {
            "amount": 700000000,
            "ccy": "USD",
            "fx": 26170,
            "fxDate": "2026-09-09"
          },
          "roundSource": "https://vir.com.vn/language-platform-prep-raises-7-million-in-series-a-funding-110821.html",
          "leadInvestor": false,
          "outcomeNote": ""
        },
        {
          "name": "Medigo",
          "url": "",
          "whatTheyDo": "Đặt thuốc và tư vấn dược sĩ 24/7 qua ứng dụng.",
          "industries": [
            "HEALTHTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Urbox",
          "url": "",
          "whatTheyDo": "Quà tặng số và chương trình khách hàng thân thiết cho doanh nghiệp.",
          "industries": [
            "MARTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Alterno",
          "url": "",
          "whatTheyDo": "Pin lưu trữ nhiệt bằng cát, thay nhiên liệu đốt trong sấy nông sản.",
          "industries": [
            "CLIMATE",
            "ENERGY"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Enfarm",
          "url": "",
          "whatTheyDo": "Cảm biến đo dinh dưỡng đất, khuyến nghị bón phân theo từng vườn.",
          "industries": [
            "AGRITECH",
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Otrafy",
          "url": "",
          "whatTheyDo": "Phần mềm quản lý hồ sơ nhà cung cấp và truy xuất nguồn gốc thực phẩm.",
          "industries": [
            "SAAS_B2B",
            "FOODBEV"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Piktina",
          "url": "",
          "whatTheyDo": "Sàn mua bán quần áo đã qua sử dụng.",
          "industries": [
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "",
      "source": "https://touchstone.vc/portfolio",
      "verifiedAt": "2026-09-25"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://touchstone.vc/",
          "fetchedAt": "2026-09-09",
          "note": "Trang chủ chính thức, mục Investment Thesis và Contact"
        }
      ],
      "lastVerifiedAt": "2026-09-09"
    },
    "updatedAt": "2026-09-27T08:55:15.752Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "vertex-ventures-seai",
    "slug": "vertex-ventures-seai",
    "name": "Vertex Ventures Đông Nam Á và Ấn Độ",
    "shortName": "Vertex Ventures",
    "type": "VC",
    "vietnamPresence": "REGION_ONLY",
    "vietnamEvidence": "",
    "website": "https://www.vertexventures.sg",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "SEED",
        "SERIES_A",
        "LATER"
      ],
      "geos": [
        "SEA"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.vertexventures.sg/apply/",
      "submitEmail": "",
      "ctaType": "apply",
      "notes": ""
    },
    "content": {
      "summary": "Quỹ đầu tư đa giai đoạn tại Đông Nam Á và Ấn Độ, công bố tham gia từ vòng seed trở đi.",
      "lookingFor": [],
      "tips": [
        "Quỹ tự mô tả không giới hạn ngành. Không nên suy ngành từ danh mục đã đầu tư."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.vertexventures.sg/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chủ chính thức — phạm vi và giai đoạn đầu tư"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "updatedAt": "2026-09-27T09:12:42.801Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "fundId": "vic-partners",
    "slug": "vic-partners",
    "name": "VIC Partners",
    "shortName": "VIC Partners",
    "type": "VC",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://vic.partners",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "SEED",
        "SEED_PLUS"
      ],
      "geos": [
        "VN"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://vic.partners/form/",
      "submitEmail": "",
      "notes": "Biểu mẫu ngắn trên trang chính thức: tên, nơi đặt trụ sở (Hà Nội hoặc TP.HCM), ngành, thị trường, một câu mô tả startup; có thể kèm số liệu lực kéo và link pitch deck hoặc dự phóng tài chính."
    },
    "content": {
      "summary": "Nhóm đầu tư do các nhà sáng lập, nhà đầu tư chuyên nghiệp và lãnh đạo doanh nghiệp lập ra (hơn 20 partner), có quỹ I từ 2016 đến 2017 và quỹ II từ 06/2021. Đầu tư vào startup có gắn với Việt Nam ở khoảng trống từ seed tới trước Series A, kèm hỗ trợ gọi vốn, tài chính, vận hành và tuyển dụng.",
      "lookingFor": [
        "Startup có mô hình kinh doanh đổi mới dựa trên công nghệ và dữ liệu, gắn với thị trường Việt Nam",
        "Đội đã qua vòng đầu và cần vốn để đi tới Series A"
      ],
      "tips": [
        "Giá trị lớn nhất là mạng lưới partner. Trong buổi đầu, hỏi cụ thể partner nào hiểu ngành của bạn và có thể giới thiệu khách hàng nào.",
        "Trang chính thức không công bố mức séc. Hỏi thẳng thay vì đoán.",
        "Biểu mẫu chỉ cần một câu mô tả, nên câu đó phải nói được khách hàng là ai, vấn đề gì và lực kéo hiện tại."
      ]
    },
    "portfolio": {
      "items": [
        {
          "name": "TopCV",
          "url": "https://www.topcv.vn",
          "whatTheyDo": "Nền tảng tuyển dụng và công nghệ nhân sự, kết nối ứng viên với nhà tuyển dụng.",
          "industries": [
            "HRTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "",
      "source": "https://vic.partners/investment-strategies/",
      "verifiedAt": "2026-10-14"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://vic.partners/about/",
          "fetchedAt": "2026-10-14",
          "note": "Giới thiệu: giai đoạn seed tới pre-Series A, quỹ I và quỹ II, tập trung Việt Nam"
        },
        {
          "url": "https://vic.partners/investment-strategies/",
          "fetchedAt": "2026-10-14",
          "note": "Chiến lược đầu tư, ví dụ TopCV"
        },
        {
          "url": "https://vic.partners/form/",
          "fetchedAt": "2026-10-14",
          "note": "Biểu mẫu nhận hồ sơ"
        }
      ],
      "lastVerifiedAt": "2026-10-14"
    },
    "updatedAt": "",
    "updatedBy": ""
  },
  {
    "fundId": "vinventures",
    "slug": "vinventures",
    "name": "VinVentures (Vingroup)",
    "shortName": "VinVentures",
    "type": "CVC",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://www.vinventures.net",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [
        "MOBILITY",
        "ROBOTICS",
        "PROPTECH",
        "HEALTHTECH",
        "ENERGY",
        "AI"
      ],
      "stages": [
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": {
          "amount": 50000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "max": null,
        "basis": "INITIAL_CHECK",
        "sourceType": "OFFICIAL",
        "confidence": "HIGH",
        "hardFilter": false,
        "verifiedAt": "2026-10-07"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://www.vinventures.net/",
      "submitEmail": "contact@vinventures.net",
      "notes": "Chương trình B.O.U.N.D 2026 là cửa vào chính. Liên hệ qua email hoặc trang chính thức để biết thời hạn nộp."
    },
    "content": {
      "summary": "Quỹ đầu tư của Tập đoàn Vingroup. Chương trình B.O.U.N.D 2026 đầu tư tối thiểu 500 nghìn USD cho mỗi startup được chọn, nhắm vào công ty đã có giải pháp chạy được và tín hiệu thương mại hoá, kết nối với các công ty trong tập đoàn.",
      "lookingFor": [],
      "tips": [
        "Lợi thế lớn nhất thường không phải tiền mà là khách hàng và kênh thử nghiệm trong hệ sinh thái Vingroup. Hãy chỉ ra cụ thể công ty nào trong tập đoàn sẽ dùng sản phẩm của bạn.",
        "Là quỹ của doanh nghiệp, mục tiêu có cả chiến lược. Hỏi rõ về quyền ưu tiên mua lại và ràng buộc độc quyền trước khi ký.",
        "VinVentures cũng phát hành báo cáo thường niên về thị trường đầu tư mạo hiểm Việt Nam, đáng đọc trước khi gặp."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.vinventures.net/",
          "fetchedAt": "2026-10-07",
          "note": "Trang chính thức, chương trình B.O.U.N.D 2026"
        }
      ],
      "lastVerifiedAt": "2026-10-07"
    },
    "updatedAt": "",
    "updatedBy": ""
  },
  {
    "fundId": "vsv-capital",
    "slug": "vsv-capital",
    "name": "VSV Capital (Vietnam Silicon Valley)",
    "shortName": "VSV Capital",
    "type": "ACCELERATOR",
    "vietnamPresence": "OFFICE",
    "vietnamEvidence": "",
    "website": "https://vsvcapital.com.vn",
    "publish": {
      "status": "PUBLISHED"
    },
    "thesis": {
      "capitalTypes": [
        "EQUITY"
      ],
      "industries": [],
      "stages": [
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "VN"
      ],
      "businessModels": [],
      "customerTypes": [],
      "instruments": [],
      "ticket": {
        "min": null,
        "max": {
          "amount": 5000000,
          "ccy": "USD",
          "fx": 26170,
          "fxDate": "2026-09-09"
        },
        "basis": "INITIAL_CHECK",
        "sourceType": "OFFICIAL",
        "confidence": "HIGH",
        "verifiedAt": "2026-10-07"
      },
      "hardRequirements": []
    },
    "process": {
      "submitUrl": "https://vsvcapital.com.vn/accelerator",
      "submitEmail": "",
      "notes": "Nộp hồ sơ trực tuyến qua F6S, phỏng vấn online, rồi trình bày trước hội đồng đầu tư tại Hà Nội. Toàn bộ quy trình bằng tiếng Anh."
    },
    "content": {
      "summary": "Chương trình tăng tốc khởi nghiệp hoạt động từ năm 2014 tại Hà Nội, dành cho startup giai đoạn pre-seed và seed. Đầu tư tối đa 50 nghìn USD mỗi đội, đổi 7 đến 10% cổ phần, kèm 4 tháng bootcamp, mỗi khoá 10 đến 15 đội.",
      "lookingFor": [],
      "tips": [
        "Tính riêng phần tiền thì định giá ngầm định khá thấp: 50 nghìn USD đổi 10% tương đương định giá sau vòng khoảng 500 nghìn USD. Phần còn lại bạn trả cho huấn luyện và mạng lưới nhà đầu tư.",
        "Trang chính thức không ghi lịch khoá mới. Hỏi trước thời hạn nộp của khoá gần nhất.",
        "Có thêm chương trình Climate Tech Catalyst cho startup nông nghiệp và kinh tế tuần hoàn."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://vsvcapital.com.vn/",
          "fetchedAt": "2026-10-07",
          "note": "Trang chính thức"
        },
        {
          "url": "https://vsvcapital.com.vn/accelerator",
          "fetchedAt": "2026-10-07",
          "note": "Điều kiện, quy mô đầu tư và quy trình"
        }
      ],
      "lastVerifiedAt": "2026-10-07"
    },
    "updatedAt": "",
    "updatedBy": ""
  }
];
